module.exports = __webpack_public_path__ + "img/thumbnail_BlackRhinoceros_f_normal.f1a8b7d4.png";